import React from 'react';
import { Atom, FlaskConical, BookOpen } from 'lucide-react';

const AUDIENCES = [
  {
    icon: Atom,
    title: 'IIT-JEE Aspirants',
    description: 'Master Physics, Chemistry, and Mathematics with AI that adapts to JEE question patterns and comprehensive syllabus coverage.',
    tag: 'Adaptive JEE practice',
  },
  {
    icon: FlaskConical,
    title: 'NEET Aspirants',
    description: 'Focused Biology, Physics, and Chemistry preparation with adaptive difficulty, aligned to NEET syllabus and exam patterns.',
    tag: 'Adaptive NEET practice',
  },
  {
    icon: BookOpen,
    title: 'Foundation Learners',
    description: 'Build strong fundamentals from the ground up - a guided starting point for learners beginning their competitive exam journey.',
    tag: 'Beginner-friendly paths',
  },
];

export default function AudienceSection({ isDarkTheme }) {
  const textColor = isDarkTheme ? 'text-white' : 'text-navy';
  const textMuted = isDarkTheme ? 'text-white/70' : 'text-text-slate';
  const cardBg = isDarkTheme ? 'bg-white/5 border-white/10 hover:border-brand-cyan/40' : 'bg-white border-gray-200 hover:border-brand-blue/40';
  const borderTop = isDarkTheme ? 'border-t border-white/10' : 'border-t border-gray-200';

  return (
    <section id="target" className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center mb-16">
        <h2 className={`font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4 ${textColor}`}>
          For Aspiring Champions
        </h2>
        <p className={`text-lg md:text-xl ${textMuted}`}>Built for serious IIT-JEE and NEET aspirants, at every stage</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {AUDIENCES.map(({ icon: Icon, title, description, tag }) => (
          <div key={title} className={`rounded-card border ${cardBg} p-8 transition-all group`}>
            <div className="p-3 rounded-btn bg-brand-gradient w-fit mb-5">
              <Icon className="text-white" size={26} />
            </div>
            <h3 className={`text-2xl font-bold ${textColor} mb-3`}>{title}</h3>
            <p className={`${textMuted} mb-4`}>{description}</p>
            <div className={`pt-4 ${borderTop}`}>
              <p className="text-brand-blue font-semibold text-sm">✓ {tag}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
